import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ArticleSkeleton = () => {
  return (
    <>
      {[...Array(5)].map((data) => (
        <div className="w-full lg:w-[90%] mx-auto xl:w-[80%] p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sec-articles-box">
          <div className="w-full md:w-[75%] lg:w-[80%] xl:w-[83%] flex gap-5 lg:gap-10">
            <div className="md:w-[20%] lg:w-[20%] xl:w-[15%] flex items-start md:items-center md:justify-center h-auto ">
              <div className="sab-part1 md:h-full md:w-full hidden md:flex md:items-center md:justify-center p-[5%]">
                <Skeleton height={40} width={40} circle={true} />
              </div>
              <div className="md:h-full md:w-full flex md:hidden md:items-center md:justify-center p-[5%]">
                <Skeleton height={40} width={40} circle={true} />
              </div>
            </div>
            <div className="w-full md:w-[80%] lg:w-[85%] sab-part2">
              <Skeleton height={20} width="70%" className="mb-[2%]" />
              <Skeleton height={30} width="90%" className="mb-[3%]" />
              <div className="w-full flex sm:flex-row flex-col gap-[1rem] md:gap-[2rem] lg:gap-[2rem]">
                <div className="w-full flex sm:flex-col sm:w-max gap-2">
                  <Skeleton height={15} width={80} />
                  <Skeleton height={15} width={70} />
                </div>
                <div className="w-full flex sm:flex-col sm:w-max gap-2">
                <Skeleton height={15} width={80} />
                <Skeleton height={15} width={70} />
                </div>
                <div className="w-full flex sm:flex-col sm:w-max gap-2">
                <Skeleton height={15} width={80} />
                <Skeleton height={15} width={70} />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-[25%] lg:w-[20%] xl:w-[17%] flex items-center md:flex-col sab-part3">
            <div className="w-[50%] flex gap-3 md:gap-5 md:mb-auto md:flex-col items-center md:w-full">
              <Skeleton height={20} width={100} />
              <div className="w-auto sm:w-[20%] md:w-full justify-center flex gap-2 items-center">
                <Skeleton height={25} width={25} circle={true} />
                <Skeleton height={20} width="30%" />
              </div>
            </div>
            <div className="w-[50%] md:w-full flex justify-end md:justify-center">
              <div className="w-max px-[3rem] py-[1rem] md:px-[3rem] md:py-[1rem] flex gap-2 items-center sabp3-btn justify-center">
                <Skeleton height={25} width={25} circle={true} />
                <Skeleton height={20} width="50%" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ArticleSkeleton;
